import { useAppStore } from '../../../store/useAppStore';
import { hasPermission as checkPermission } from '../../auth/permissions';
import { Permission, type Role } from '../../auth/types';

export function useShowGettingStartedWizard(): boolean {
    const member = useAppStore((s) => s.cloud.member);
    const roles = useAppStore((s) => s.admin.roles);
    const actsCount = useAppStore((s) => s.showStructure.acts?.length ?? 0);

    if (!member) return false;
    if (member.onboardingDismissed) return false;
    if (actsCount > 0) return false;

    const role = roles.find((candidate: Role) => candidate.id === member.roleId);
    return checkPermission(role, Permission.MANAGE_PROJECT);
}
